let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7n4tg")).then(() => parcelRequire('4nIwV'));